import React, { useContext, useState } from 'react'
import { Box, TextField, Button, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Sidebar from './sidebar'
import CustomToolbar from './CustomToolbarPrint'
import DataContext from '../context/context'
import ProjectFilter from './ProjectFilter'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { inDateRange, matchesProject } from '../utils/reportUtils'
import getCorrespondenceTypes from '../utils/correspondenceTypes'

export default function CorrespondenceReport() {
  const dropDownData = useContext(DataContext)
  const [date1, setdate1] = useState('')
  const [date2, setdate2] = useState('')
  const [projectFilter, setprojectFilter] = useState([])
  const [rows, setRows] = useState([])
  const [rows1, setRows1] = useState([])

  const handleProjects = (projects) => {
    setprojectFilter(projects)
    setRows([])
    setRows1([])
  }

  const summaryColumns = [
    { field: 'concType', headerName: 'Correspondence Type', width: 300 },
    { field: 'count', headerName: 'Count', width: 150 },
  ]

  const columns = [
    { field: 'firstName', headerName: 'Name', width: 200 },
    { field: 'surName', headerName: 'Surname', width: 200 },
    { field: 'count', headerName: 'Correspondence Count', width: 200 },
  ]

  const getData = async () => {
    if (projectFilter.length === 0) {
      setRows([])
      setRows1([])
      return
    }
    const q = collection(db, 'employee')
    const querySnapshot = await getDocs(q)

    const typeOptions = new Set(getCorrespondenceTypes(dropDownData))
    const typeTotals = {}
    const details = []

    querySnapshot.forEach((document) => {
      const e = document.data()
      if (!matchesProject(e.gender, projectFilter)) return
      const conc = Array.isArray(e.conc) ? e.conc : []
      let count = 0
      conc.forEach((c) => {
        if (!c) return
        const concType = c.concType || ''
        if (concType) typeOptions.add(concType)
        if (!inDateRange(c.concDate, date1, date2)) return
        count += 1
        const totalKey = concType || 'Unspecified'
        typeTotals[totalKey] = (typeTotals[totalKey] || 0) + 1
      })
      if (count === 0) return
      details.push({
        id: document.id,
        firstName: e.firstName || '',
        surName: e.surName || '',
        count,
      })
    })

    details.sort((a, b) =>
      a.surName.localeCompare(b.surName) || a.firstName.localeCompare(b.firstName)
    )

    const summary = Array.from(typeOptions)
      .filter(Boolean)
      .map((type) => ({
        id: type,
        concType: type,
        count: typeTotals[type] || 0,
      }))
    if (typeTotals.Unspecified) {
      summary.push({ id: 'unspecified', concType: 'Unspecified', count: typeTotals.Unspecified })
    }
    summary.push({ id: 'total', concType: 'Total', count: details.reduce((total, d) => total + d.count, 0) })

    setRows(details)
    setRows1(summary)
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: '50px' }}>
        <div style={{ width: '100%' }}>
          <ProjectFilter value={projectFilter} onChange={handleProjects} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="Start Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate1(e.target.value)} value={date1} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="End Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate2(e.target.value)} value={date2} />
          <Button onClick={getData} disabled={projectFilter.length === 0} className="addform" variant="contained" style={{ marginBottom: '10px', width: '100%', height: '50px', marginTop: '30px', backgroundColor: '#F21D2F' }}>Search</Button>

          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Overall Summary</Typography>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Total correspondences: {rows1.find((row) => row.id === 'total')?.count || 0}
          </Typography>
          <div style={{ height: '35vh', marginBottom: '20px' }}>
            <DataGrid rows={rows1} columns={summaryColumns} pageSize={25} rowsPerPageOptions={[25]} components={{ Toolbar: CustomToolbar }} />
          </div>

          <Typography variant="h6" sx={{ mb: 1 }}>Breakdown by Beneficiary</Typography>
          <div style={{ height: 440 }}>
            <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[5]} components={{ Toolbar: CustomToolbar }} />
          </div>
        </div>
      </Box>
    </Box>
  )
}
